/**
 * 签名，加密函数
 * http://www.tcatgpt.com/post/10953.html
 */

import smCrypto from 'sm-crypto'
import storage, { TOKEN_INFO } from './storage'
import { ElMessage } from 'element-plus'

const sm2 = smCrypto.sm2

/**
 * 加密函数
 * @param {*} data
 * @returns
 */
export const doEncrypt = (data) => {
  try {
    const { tokenValue } = storage.getItem(TOKEN_INFO) || {}

    const timestamp = new Date().getTime()
    // 先用token和时间戳对私钥1签名
    const sign = sm2.doSignature(`${tokenValue}-${timestamp}`, __SYS_CONFIG.privateKey1, { hash: true })

    // 再用公钥2对签名信息和请求参数进行加密得到加密信息将加密信息发送给后端
    const encryptString = sm2.doEncrypt(
      JSON.stringify({
        sign,
        timestamp,
        data
      }),
      __SYS_CONFIG.publicKey2
    )
    return {
      encrypt: encryptString
    }
  } catch (error) {
    ElMessage.error('加密失败, 请联系管理')
  }
}

export const doDecrypt = (data) => {
  try {
    const { tokenValue } = storage.getItem(TOKEN_INFO) || {}

    // 先用私钥1对加密信息进行解密
    let decryptData = sm2.doDecrypt(data.encrypt, __SYS_CONFIG.privateKey1)
    decryptData = JSON.parse(decryptData)

    // 用token和时间戳对签名进行验证
    const flag = sm2.doVerifySignature(
      `${tokenValue}-${decryptData.timestamp}`,
      decryptData.sign,
      __SYS_CONFIG.publicKey2,
      { hash: true }
    )
    if (flag) {
      return decryptData.data
    }
  } catch (error) {
    ElMessage.error('解密失败, 请联系管理')
  }
}
